import { Container, Row, Col } from 'reactstrap'

import { LandingHeroStoreButtons } from './LandingHeroStoreButtons.tsx'

export default function FirstSection() {
  return (
    <section className="hero-section">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      {/* Phone-like frame overlay */}
      <div className="phone-frame" />
      <Container fluid>
        <Row className="hero-content">
          <Col lg="12" className="hero-text">
            <h3 className="hero-kicker">A nova maneira de</h3>
            <h1 className="hero-title">JOGAR TENNIS</h1>
            <p className="hero-subtitle">
              Encontre tenistas perto de você, ganhe pontos no Ranking e acumule Conquistas.
            </p>
            <LandingHeroStoreButtons />
          </Col>
        </Row>
      </Container>
    </section>
  )
}
